import { getAnalytics } from "@tm/insurance/analytics";
import { trackEvent } from "@tm/insurance/analytics/xdm";
import { getPartnerOnClientSide } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import {
  AnchorTag,
  FormattedText,
  ImageComponent,
  ParaTag,
  SpanTag,
} from "@tm/static";
import { theme } from "@tm/utility/global";
import React from "react";
import { TagWrap, VendorWrap } from "./InsurancePlans.style";
import EnhancedLinksSection from "./MoreBenefits/EnhancedLinksSection";
import { insurancePlanCompType } from "./type";

const analytics = getAnalytics();

const InsPlanModalCommonInfo = ({
  data,
  isAddOnBenefits,
  tag,
}: insurancePlanCompType) => {
  const partner = getPartnerOnClientSide();
  return (
    <React.Fragment>
      {data?.packName && (
        <ParaTag
          fontSize="xs"
          fontWeight="black"
          // color={data?.packNameColor}
          margin="0 0 4px"
        >
          <FormattedText value={data?.packName} />
        </ParaTag>
      )}
      {tag && (
        <TagWrap>
          <FormattedText value={tag} />
        </TagWrap>
      )}
      {data.insuranceType && (
        <VendorWrap margin={isAddOnBenefits ? "0px 0px 8px 0px" : "0"}>
          {data?.vendorDisplayIcon && (
            <ImageComponent
              src={data?.vendorDisplayIcon}
              height="34px"
              width="32px"
              // margin="0px 0px 4px 0px"
            ></ImageComponent>
          )}
          <ParaTag
            fontSize={isAddOnBenefits ? "md" : "large"}
            margin="0 0 4px"
            color={theme.blackText}
            fontWeight="black"
          >
            <FormattedText value={data?.insuranceType} />
          </ParaTag>
        </VendorWrap>
      )}
      {data.insPlanName && (
        <ParaTag fontSize="xs" margin="0 0 4px">
          <SpanTag fontSize="xs" color={theme.greyText7}>
            {data?.vendorDisplayPrefix}{" "}
            <FormattedText value={data?.insPlanName} />
          </SpanTag>
        </ParaTag>
      )}
      {data?.ctaLink && (
        <AnchorTag
          fontSize="xs"
          margin="0 0 16px"
          hrefProp={data?.tncLink}
          targetProp="_blank"
          handleClick={() => {
            try {
              analytics?.trackListingEvents(
                { actionType: "Tnc_clicked" } as any,
                "click"
              );
              trackEvent({
                event_detail: {
                  event_type: "action",
                  event_name: "component_cta-clicked",
                  event_value: "Tnc_clicked",
                },
              });
            } catch (err) {
              console.error("TnC click tracking failed", err);
            }
          }}
        >
          <FormattedText value={data?.ctaLink} />
        </AnchorTag>
      )}
      {partner === PARTNER.MYPARTNER && (
        <EnhancedLinksSection
          links={(data as any)?.links}
          ctaLink={(data as any)?.ctaLink}
          tncLink={(data as any)?.tncLink}
          quoteId={(data as any)?.quoteId}
          csrfToken={(data as any)?.csrfToken}
        />
      )}
      {data?.planExtraInfo && (
        <SpanTag fontSize="xs" color={theme.greyText7} margin="0 0 14px">
          <FormattedText value={data?.planExtraInfo} />
        </SpanTag>
      )}
      {data?.service && (
        <SpanTag fontSize="xs" color={theme.greyText7} margin="0 0 14px">
          <FormattedText value={data?.service} />
        </SpanTag>
      )}
    </React.Fragment>
  );
};

export default InsPlanModalCommonInfo;
